module.exports = __webpack_public_path__ + "img/public/SiteIcons/sliderNextArrow.svg?83d18090";